/**
 * @module ui/time-since
 */
import since from "utils/time-since";
import { toArray } from "utils/utils";

export default function displayTimeSince() {
  const els = toArray(document.getElementsByClassName("js-story-moment"));
  els.forEach(el => {
    const specialLabel = el.innerHTML.match(/<span class="c-timestamp__label">(\w+)<\/span>/i);
    const moment = since(el.dataset.unixtime);
    if (!specialLabel) {
      el.innerHTML = `${el.dataset.momentPreface ? el.dataset.momentPreface : ""}${moment}`;
    } else {
      el.innerHTML = `<span class="c-timestamp__label">${specialLabel[1]}</span> ${el.dataset.momentPreface ?
        el.dataset.momentPreface : ""}${moment}`;
    }
  });
  return els;
}
